import AppLoader from '@/components/AppLoader';
import { useMediaQuery } from '@chakra-ui/react';
import { Suspense, lazy } from 'react';
import { IGridMobileProps } from './week-grid-mobile.view';

const GridMobile = lazy(() => import('./week-grid-mobile.view'));

export default function LazyMobile(props: IGridMobileProps) {
	const [isLg] = useMediaQuery('(min-width: 62em)');
	if (isLg) {
		return null;
	}
	return (
		<Suspense fallback={<AppLoader />}>
			<GridMobile
				selectedDay={props.selectedDay}
				from={props.from}
				locale={navigator.language}
				onDayClick={props.onDayClick}
				onNextClick={props.onNextClick}
				onPrevClick={props.onPrevClick}
				onSlotClick={props.onSlotClick}
				slots={props.slots}
				timeZone={props.timeZone}
				onUnitsChange={props.onUnitsChange}
				maxUnitsPerBooking={props.maxUnitsPerBooking}
				unitsLabel={props.unitsLabel}
				value={props.value}
			/>
		</Suspense>
	);
}
